// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"756":"ed78eda5","773":"ed78eda5"}[chunkId] + ".chunk.css";
};